<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0" >
        Solicitudes de ausencias
      </h2>
    </div>
    <div v-if="loading" class="text-center my-4">
      <span>Cargando solicitudes...</span>
    </div>
    <div v-else>
      <div v-if="requests.length === 0" class="text-center py-5">
        <span>No hay solicitudes pendientes.</span>
      </div>
      <div v-else class="vacation-cards-list">
        <b-row class="g-3">
          <b-col v-for="request in requests" :key="request.id" cols="12" md="6" class="mb-1">
            <div class="">
              <div class="card-body vacation-card">
                <div class="card-row">
                  <div class="card-main">
                    <div v-if="request.user" class="card-employee">
                      <b-avatar variant="dark" size="md" :src="request.user.avatar_url" />
                      <span class="ml-1">
                      <b-link
                          :to="{ name: 'viewUser', params: { id: request.user.id } }"
                          class="link"
                      >
                        {{ getEmployeeName(request) }}
                      </b-link>
                    </span>
                    </div>
                    <div class="card-status">
                      <span class="badge badge-warning">Pendiente</span>
                    </div>
                  </div>
                  <div class="card-details">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <span class="fw-bold" v-if="request.type.name !== 'Horas de ausencia'">{{ request.requested_days }} días de {{ request.type.name }}</span>
                      <span class="fw-bold" v-else>{{ request.requested_days }} {{ request.type.name }}</span>
                      <span v-if="request.comment" class="card-motivo-small">{{ request.comment }}</span>
                    </div>
                    <div class="card-dates">
                      <small>Desde</small> <span class="date">{{ formatDate(request.start_date) }}</span>
                      <small class="mx-2">Hasta</small> <span class="date">{{ formatDate(request.end_date) }}</span>
                    </div>
                  </div>
                </div>
                <div class="card-actions mt-2">
                  <span
                    class="cursor-pointer"
                    :class="request.files && request.files.length > 0 ? 'text-success' : 'text-muted'"
                    :title="request.files && request.files.length > 0 ? 'Ver justificantes' : 'Añadir justificante'"
                    @click="openJustificanteModal(request)"
                  >
                    <feather-icon icon="PaperclipIcon" size="18" />
                  </span>
                  <div>
                    <button class="btn btn-outline-success btn-sm mr-2" @click="approveRequest(request.id)" :disabled="actionLoading === request.id">
                      Aprobar
                    </button>
                    <button class="btn btn-outline-danger btn-sm" @click="rejectRequest(request.id)" :disabled="actionLoading === request.id">
                      Rechazar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <absence-document-modal
      v-model="showJustificanteModal"
      :absence-id="justificanteRequest ? justificanteRequest.id : null"
      :files="justificanteRequest ? justificanteRequest.files : []"
      @updated="justificanteRequest = { ...justificanteRequest, files: $event }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BRow, BCol, BAvatar, BLink, BButton } from 'bootstrap-vue'
import AbsenceDocumentModal from '@/components/absences/AbsenceDocumentModal.vue'

export default {
  name: 'VacationRequestsAdmin',
  components: {
    BLink,
    BAvatar,
    BButton,
    BRow,
    BCol,
    AbsenceDocumentModal,
  },
  data() {
    return {
      loading: false,
      actionLoading: null,
      showJustificanteModal: false,
      justificanteRequest: null,
    }
  },
  computed: {
    ...mapGetters({
      requests: 'absences/getItems',
      currentClient: 'clients/getCurrentClient',
    }),
  },
  methods: {
    ...mapActions({
      fetchRequests: 'absences/getListAbsences',
      approve: 'absences/approve',
    }),
    getEmployeeName(request) {
      if (request.user && request.user.name) return request.user.name
      return 'Sin nombre'
    },
    async refreshRequests() {
      this.loading = true
      try {
        await this.fetchRequests({
          page: 1,
          per_page: 100,
          type_id: '',
          user_id: '',
          date_ini: '',
          date_fin: '',
          status: 'pending',
          client_id: this.currentClient && this.currentClient.id ? this.currentClient.id : '',
        })
      } finally {
        this.loading = false
      }
    },
    async approveRequest(id) {
      this.actionLoading = id
      try {
        const formData = new FormData()
        formData.append('status', 'approved')
        await this.approve({ id, absence: formData })
      } finally {
        this.actionLoading = null
      }
    },
    async rejectRequest(id) {
      this.actionLoading = id
      try {
        const formData = new FormData()
        formData.append('status', 'denied')
        formData.append('comment', 'Rechazado por el administrador')
        await this.approve({ id, absence: formData })
        this.refreshRequests()
      } finally {
        this.actionLoading = null
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const d = new Date(dateStr)
      return d.toLocaleDateString()
    },
    openJustificanteModal(request) {
      this.justificanteRequest = { ...request, files: [...(request.files || [])] }
      this.showJustificanteModal = true
    },
  },
  async mounted() {
    await this.refreshRequests()
  },
}
</script>

<style scoped>
.vacation-cards-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.vacation-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border: 1px solid #e0e6ed;
  padding: 0;
  margin-left: 0;
  margin-right: 0;
}
.card-body {
  padding: 1.2rem 1.5rem;
}
.card-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.card-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-employee {
  font-size: 1.1em;
  color: #2a3a4a;
}
.card-status {
  display: flex;
  align-items: center;
}
.card-details {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 0.98em;
  color: #4a4a4a;
}
.card-dates {
  font-size: 0.92em;
  color: #6c7a89;
  margin-top: 0.2em;
}
.card-dates .date {
  font-weight: 500;
  margin-right: 0.5em;
}
.card-motivo {
  font-size: 1em;
  color: #2a3a4a;
  margin-left: 1.5em;
}
.card-motivo-small {
  font-size: 0.85em;
  font-style: italic;
  color: #8a8a8a;
  margin-left: 1.2em;
}
.card-actions {
  display: flex;
  justify-content: space-between;
  gap: 0.7rem;
}
.btn-success, .btn-danger {
  min-width: 80px;
}
</style>
